/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Hex from 'solis/type/hex';

import Args from 'solis/claude/action/args';

import { isColonyRimHex } from 'solis/claude/logic/board/placement';


// Zone clicks narrow the docking ring to that colony's rim — clicking the narrowed
// colony again widens back out. The picked spot survives when it stays legal in the new
// scope (only the position stepper resets, so the footprint re-ranks against the chosen
// colony) and clears otherwise, so it never resurrects without a fresh click. A spot
// valid in the current scope stays legal under a colony iff it lies on its rim, and
// widening never invalidates one. Empty hexes pick the placement spot.
export default class
{
  onSelect (zone, entityHex, { navigation, dispatch })
  {
    if (zone === null)
    {
      dispatch.replaceArgs({ [Args.AnchorTarget]: entityHex.toString() });

      return;
    }

    const colonyID = navigation.getArg(Args.AnchorColony) === zone.cass.colony ? null : zone.cass.colony;

    const target = navigation.getArg(Args.AnchorTarget);

    const keep = target && (colonyID === null || isColonyRimHex(zone.parent, new Hex(target), colonyID));

    dispatch.replaceArgs(keep ? { [Args.AnchorColony]: colonyID, [Args.AnchorTarget]: target } : { [Args.AnchorColony]: colonyID });
  }


  isSelected ()
  {
    return false;
  }


};
